const CommonButton = ({ btnText, onClick = () => {}, loading = false, id = "new-btn", isWhiteBtn }) => {
   return (
      <button
         id={id}
         onClick={onClick}
         className={`pg-comman-button-new-ui ${isWhiteBtn ? "pg-white-button" : "pg-blue-button"}`}
      >
         {loading ? <div style={{ width: "2.5rem", height: "2.5rem" }} className="spinner-border"></div> : btnText}
      </button>
   );
};

export default CommonButton;
